/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});


	$gl2.on("init", (event, slick) => {
	  $photosCounterFirstSpan.text(`${slick.currentSlide + 1}/`);
	  jQuery(".photos-counter span:nth-child(2)").text(slick.slideCount);
	});
	 





	$gl.slick({
	  rows: 0,
	  slidesToShow: 4,
	  arrows: false,
	  draggable: false,
	  useTransform: false,
	  mobileFirst: true,
	  autoplay: true,
	  asNavFor: $gl2,
	  responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 6
	      }
	    },
	    {
	      breakpoint: 1023,
	      settings: {
	        slidesToShow: 1,
	        vertical: true
	      }
	    }
	  ]
	});
	 
	$gl2.slick({
	  rows: 0,
	  useTransform: false,
	  prevArrow: ".arrow-left",
	  nextArrow: ".arrow-right",
	  fade: true,
	  autoplay: true,
	  asNavFor: $gl
	});


	var lightbox = jQuery('.img-gallery a').simpleLightbox();
	var lightbox2 = jQuery('.gallery a').simpleLightbox();

}); 

const $left = jQuery(".left");
const $gl = jQuery(".single-gallery");
const $gl2 = jQuery(".single-gallery2");
const $photosCounterFirstSpan = jQuery(".photos-counter span:nth-child(1)");

function handleCarouselsHeight() {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    const gl2H = jQuery(".single-gallery2").height();
    $left.css("height", gl2H);
  } else {
    $left.css("height", "auto");
  }
}

jQuery(".single-gallery .item").on("click", function() {
  const index = jQuery(this).attr("data-slick-index");
  $gl2.slick("slickGoTo", index);
});

$gl2.on("afterChange", (event, slick, currentSlide) => {
  $photosCounterFirstSpan.text(`${slick.currentSlide + 1}/`);
});


	jQuery(window).on("load", () => {
  
	  setTimeout(() => {
	  	jQuery(".loading").fadeOut()
	    jQuery("body").addClass("over-visible");
	  }, 300);
	});


jQuery(window).on(
  "resize",
  _.debounce(() => {
    handleCarouselsHeight();
  }, 200)
);


